var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-word-cloud',{attrs:{"words":_vm.weightedWords,"font-family":_vm.fontFamily,"color":_vm.setWordColor,"spacing":_vm.letterSpacing,"animation-duration":_vm.duration,"font-size-ratio":_vm.letterRatio}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }